import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EventSpace } from "@models/space";
import { SnackBarService } from "@services/snack-bar.service";
import { sameSpaceData } from "@services/event-spaces-sync.service";
import { finalize, take } from "rxjs";
import { ButtonComponent } from "../../../../../../shared/components/button/button.component";
import { EventTicketBatch } from "../../../../../../shared/components/modal-tickets/types/ticket-batch.type";
import {
  SpaceEditDialogData,
  SpaceEditModalComponent,
} from "./space-edit-modal/space-edit-modal.component";

@Component({
  selector: "app-event-spaces-step",
  imports: [CommonModule, CurrencyPipe, ButtonComponent],
  templateUrl: "./event-spaces-step.component.html",
  styleUrl: "./event-spaces-step.component.scss",
})
export class EventSpacesStepComponent {
  private readonly dialog = inject(MatDialog);
  private readonly snackbarService = inject(SnackBarService);
  private spaceDialogOpen = false;

  @Input({ required: true }) spaces: EventSpace[] = [];
  @Input() ticketBatches: EventTicketBatch[] = [];
  @Output() spacesChange = new EventEmitter<EventSpace[]>();

  openSpaceModal(space?: EventSpace): void {
    if (this.spaceDialogOpen) return;
    this.spaceDialogOpen = true;
    const dialogRef = this.dialog.open(SpaceEditModalComponent, {
      width: "700px",
      disableClose: true,
      data: { space, ticketBatches: this.ticketBatches } as SpaceEditDialogData,
    });

    dialogRef
      .afterClosed()
      .pipe(
        take(1),
        finalize(() => (this.spaceDialogOpen = false)),
      )
      .subscribe((result: EventSpace | undefined) => {
        if (!result) return;

        const duplicate = this.spaces.some(
          (existing) =>
            existing !== space &&
            (!existing.id || !result.id || existing.id === result.id) &&
            sameSpaceData(existing, result),
        );
        if (duplicate) {
          this.snackbarService.openSnackBar(
            "Este camarote já está na lista com os mesmos dados. A cópia não foi adicionada.",
            "Fechar",
            "info",
          );
          return;
        }

        if (space) {
          const updatedSpaces = this.spaces.map((mapSpace) =>
            mapSpace === space ? result : mapSpace,
          );
          this.spacesChange.emit(updatedSpaces);
        } else {
          this.spacesChange.emit([...this.spaces, result]);
        }
      });
  }

  getFinalPrice(price: number, consumption: number): number {
    const numericPrice = Number(price);
    const numericConsumption = Number(consumption);
    return numericPrice + numericConsumption + numericPrice * 0.1;
  }

  removeSpace(space: EventSpace): void {
    if (space.sold_quantity && space.sold_quantity > 0) {
      this.snackbarService.openSnackBar(
        "Não é possível remover um espaço que já possui vendas.",
        "Fechar",
        "error",
      );
      return;
    }

    const updatedSpaces = this.spaces.filter((s) => s !== space);
    this.spacesChange.emit(updatedSpaces);

    this.snackbarService.openSnackBar(
      "Espaço removido. Salve o evento para confirmar as alterações.",
      "Fechar",
      "success",
    );
  }
}
